//! Web
export const get_reports = 'api/common/get-reports';

//! Site Settings (public)
export const get_site_settings = 'api/common/get-site-settings';

//! Awards (public)
export const get_awards = 'api/common/get-awards';

//! Media Coverage (public)
export const get_media_coverage = 'api/common/get-media-coverage';

//! Videos (public)
export const get_videos = 'api/common/get-videos';

//! Blogs (public)
export const get_blogs = 'api/common/get-blogs';
export const get_blog_by_id = (blogId) => `api/common/get-blog/${blogId}`;

//! Partner
export const get_partner_details = ({ partnerId }) => `api/common/get-partner-details?partnerId=${partnerId}`;

//! Community Members
export const get_community_members = 'api/common/get-community-member';

//! Static Page
export const get_terms_of_use = 'api/common/get-static-page?type=Terms-Of-Use&user_type=Customer';
export const get_privacy_policy = 'api/common/get-static-page?type=Privacy-Policy&user_type=Customer';
export const get_refund_policy = 'api/common/get-static-page?type=Refund-Policy&user_type=Customer';
export const get_about_us = 'api/common/get-static-page?type=About-Us&user_type=Customer';
export const get_shipping_policy = 'api/common/get-static-page?type=Shipping-Policy&user_type=Customer';
